module.exports = __webpack_public_path__ + "img/system-pvp-title.b4dbb81c.png";